module.exports = __webpack_public_path__ + "static/media/car_check.d98447c5.svg";